/* eslint-disable no-restricted-syntax,no-prototype-builtins */
import api from '../../utils/apiFetch';

const path = 'memberships';

const serialize = (obj) => {
  const str = [];
  for (const p in obj)
    if (obj.hasOwnProperty(p)) {
      str.push(`${encodeURIComponent(p)}=${encodeURIComponent(obj[p])}`);
    }
  return str.join('&');
};

export default {
  getMerchantMembershipConfig: () => api.get(`${path}/configs`),
  setMerchantMembershipConfig: (payload) =>
    api.post(`${path}/configs`, payload),
  setSponsorImage: (payload) =>
    api.file(`${path}/upload-sponsor-image`, payload),
  setAutomaticStoreCredit: (payload) =>
    api.post(`${path}/store-credits`, payload),
  createMembershipDiscount: (payload) => api.post(`${path}/discounts`, payload),
  createMembershipPlan: (payload) => api.post(`${path}/plans`, payload),
  deleteMembershipDiscount: (id) => api.post(`${path}/discounts/${id}`),
  updateAutomaticStoreCredit: (payload) =>
    api.put(`${path}/store-credits`, payload),
  updateMembership: (payload) => api.put(`${path}/member`, payload),
  addMemberCardOnFile: (payload) =>
    api.post(`${path}/member/card-on-file`, payload),
  getCloverIframeToken: (businessId) =>
    api.get(`checkout/clover-token?businessId=${businessId}`),
  getMembershipPlans: () => api.get(`${path}/plans`),
  getPrimaryMembershipPlans: () => api.get(`${path}/primary-plans`),
  getCheckInList: (params) =>
    api.get(`${path}/check-in/list?${serialize(params)}`),
  getMembershipList: (params) => api.get(`${path}/list?${serialize(params)}`),
  getSharedMembershipConfigs: (params) =>
    api.get(`${path}/secondary?${serialize(params)}`),
  getMembershipPlanStoreCreditList: () => api.get(`${path}/store-credits`),
  getMembershipDiscountsList: () => api.get(`${path}/discounts`),
  resendEmail: (payload) =>
    api.post(`${path}/resend/${payload.id}`, { type: payload.type }),
  restartEmail: (payload) => api.post(`${path}/restart/${payload.id}`),
  cancelMembership: (id) => api.post(`${path}/cancel/by-merchant/${id}`),
  deactivateMembership: (id) => api.post(`${path}/deactivate/${id}`),
  deleteMembership: (id) => api.post(`${path}/delete/${id}`),
  setMembershipCoupon: (payload) =>
    api.post(`${path}/membership-coupons`, payload),
  createMembershipLoyalty: (payload) =>
    api.post(`${path}/membership-loyalties`, payload),
  getMemberShipCouponPlanList: (params) =>
    api.get(`${path}/membership-coupon-list?${serialize(params)}`),
  getMemberShipLoyaltyPlanList: (params) =>
    api.get(`${path}/membership-loyalty-plans?${serialize(params)}`),
  setMembershipCouponEnable: (id, enable, type) =>
    api.get(
      `${path}/membership-coupon-enable/${id}?enable=${enable}&type=${type}`
    ),
  setMembershipLoyaltyEnable: (payload) =>
    api.post(`${path}/membership-loyalty-plan`, payload),
  deleteMembershipCouponPlan: (id) =>
    api.get(`${path}/membership-coupon-delete/${id}`),
  updateMembershipExpirationDate: (payload) =>
    api.post(`${path}/expiration-date`, payload),
  updateMembershipPlan: (payload) =>
    api.post(`${path}/membership-plan`, payload),
  reactiveMembership: (payload) => api.post(`${path}/reactive`, payload),
  restartCanceledMembership: (id) => api.post(`${path}/restart-canceled/${id}`),
  getMembershipFreeItemConfigs: () => api.get(`${path}/free-item-configs`),
  createMembershipFreeItemConfig: (payload) =>
    api.post(`${path}/create-free-item-configs`, payload),
  getMembershipPerks: (params) => api.get(`${path}/perks?${serialize(params)}`),
  updateMembershipPerks: (payload) =>
    api.post(`${path}/free-item-configs`, payload),
  updatePlan: (payload) => api.put(`${path}/plan`, payload),
  changePlanStatus: (payload) =>
    api.post(`${path}/plan/${payload.id}/status/${payload.status}`),
  updateMembershipTimePause: (payload) =>
    api.post(`${path}/update-time-pause`, payload),
  setMembershipResume: (id) => api.get(`${path}/resume/${id}`),
  getTransactionList: (id) => api.get(`${path}/${id}/transactions`),
  createMemberShip: (payload) => api.post(`${path}/add-membership`, payload),
  addSecondaryMemberShip: (payload) =>
    api.post(`${path}/add-secondary-membership`, payload),
  validateMembershipCode: (payload) =>
    api.post(`${path}/validate-membership-code`, payload),
  getByCode: (payload) =>
    api.get(`${path}/${payload.businessId}/get-by-code?code=${payload.code}`),
  updateMembershipRenewal: (payload) =>
    api.get(`${path}/auto-renewal/${payload.id}/${payload.autoRenewal}`),
  editCheckIn: (payload) => api.post(`${path}/check-in/edit`, payload),
  bulkEditCheckIn: (payload) => api.post(`${path}/check-in/bulk-edit`, payload),
  getPlanMembershipApi: (params) =>
    api.get(`${path}/customers-by-plan?${serialize(params)}`),
  getCheckInStats: (params) =>
    api.get(`${path}/check-in-stats?${serialize(params)}`),
  getSpendStats: (params) =>
    api.get(`${path}/spend-stats?${serialize(params)}`),
  getSpendList: (params) => api.get(`${path}/spend-list?${serialize(params)}`),
  getSecondarySpendList: (params) =>
    api.get(`${path}/secondary-spend-list?${serialize(params)}`),
  getLocationSpendList: (params) =>
    api.get(`${path}/location-spend-list?${serialize(params)}`),
  getLoyaltyPoint: (params) =>
    api.get(`${path}/check-in-loyalties?${serialize(params)}`),
  sendCustomEmail: (payload) => api.post(`${path}/send-custom-email`, payload),
  saveCheckInLoyalty: (payload) =>
    api.post(`${path}/check-in-loyalties`, payload),
  fetchWaiverTemplates: (apiKey) =>
    api.post(`waiver/templates`, {
      apiKey,
    }),
  fetchWaiverTemplateList: () => api.get('waivers/templates'),
  chargeMembership: (id) => api.post(`${path}/charge/${id}`),
  getMembershipInfo: (id) =>
    api.get(`${path}/${id}/info?extraFields=renewChargeAmount`),
  updateMembershipWaiver: (payload) =>
    api.put(`${path}/waiver-status/${payload.id}/${payload.waiverStatus}`, {}),
  deleteMiscLocation: (id) => api.delete(`${path}/prefer-location/${id}`),
  getMiscLocations: () => api.get(`${path}/prefer-locations`),
  setMiscLocations: (payload) => api.post(`${path}/prefer-location`, payload),
  deleteTsApi: (id) => api.delete(`${path}/tshirt-size/${id}`),
  setupTsSizeApi: (payload) => api.post(`${path}/tshirt-size`, payload),
  getTsSizesApi: () => api.get(`${path}/tshirt-sizes`),
  postStaffs: (payload) => api.post(`merchants/staffs`, payload),
  getStaffs: (params = {}) => api.get(`merchants/staffs?${serialize(params)}`),
  deleteAutoSignUpApi: (id) =>
    api.delete(`${path}/membership-loyalty-plan/${id}`),
};
